import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionManual";
import { PostComisionManualExcel } from "../../../reducers/comisionManual";

export interface CargaComisionesManualesDispatcher {
  cargarComisionesDesdeExcel: (
    file: File,
    confirmar: boolean
  ) => Promise<Preview<PostComisionManualExcel>>;
  clearComisionesManualExtras: () => Preview<any>;
}

export const cargaComisionesManualesDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => CargaComisionesManualesDispatcher = dispatch => ({
  cargarComisionesDesdeExcel: (file: File, confirmar: boolean) => {
    return dispatch(actions.cargarComisionesDesdeExcel(file, confirmar));
  },
  clearComisionesManualExtras: () => {
    return dispatch(actions.clearComisionesManualExtras());
  }
});
